import gql from 'graphql-tag'

export const updateNewsCategory = ({ id, data }) => {
	return {
		mutation: gql`
			mutation (
				$news_categories_id: bigint!
				$object: news_categories_set_input!
			) {
				update_news_categories_by_pk(
					pk_columns: { id: $news_categories_id }
					_set: $object
				) {
					id
				}
			}
		`,
		variables: {
			object: data,
			news_categories_id: id
		}
	}
}
